import React, { Fragment } from 'react';
import Types from 'prop-types';
import requiredIf from 'react-required-if';
import { FormattedMessage } from 'react-intl';
import { ChevronRight as Chevron } from '@transferwise/icons';
import { useTheme } from '@wise/components-theming';
import Badge from '../../../../common/Badge';
import isActiveLink from '../../../../../../common/utils/isActiveLink';
var ItemContent = function ItemContent(_ref) {
  var translationKey = _ref.translationKey,
    Icon = _ref.Icon,
    hasCaret = _ref.hasCaret,
    badge = _ref.badge,
    translatedText = _ref.translatedText,
    activePath = _ref.activePath,
    link = _ref.link;
  var _useTheme = useTheme(),
    isModern = _useTheme.isModern;
  return /*#__PURE__*/React.createElement(Fragment, null, Icon && /*#__PURE__*/React.createElement(Icon, {
    className: "tw-public-nav__menu-item-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "tw-public-nav__menu-item-text text-ellipsis ".concat(isActiveLink(link, activePath) ? 'is-active' : '')
  }, badge && /*#__PURE__*/React.createElement(Badge, {
    translationKey: badge,
    className: "hidden-xs hidden-sm m-r-1"
  }), translationKey && /*#__PURE__*/React.createElement(FormattedMessage, {
    id: translationKey
  }), translatedText && /*#__PURE__*/React.createElement("span", null, translatedText), badge && /*#__PURE__*/React.createElement(Badge, {
    translationKey: badge,
    className: "visible-xs-inline-block visible-sm-inline-block m-l-1"
  })), hasCaret && isModern && /*#__PURE__*/React.createElement("svg", {
    className: "tw-link-with-chevron-icon",
    width: "4",
    height: "8",
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96289 3.99999L0.962891 7.46409L0.962891 0.535889L3.96289 3.99999Z",
    fill: "var(--color-interactive-primary)"
  })), hasCaret && !isModern && /*#__PURE__*/React.createElement(Chevron, {
    className: "tw-link-with-chevron-icon"
  }));
};
ItemContent.defaultProps = {
  hasCaret: false,
  badge: '',
  Icon: null,
  activePath: null,
  link: null
};
export default ItemContent;